import React, { createContext, useState } from 'react';
import { MobileVerifyResponseType, verifyCustomerMobile } from '../hooks/useMobileVerify';

export interface MobileVerifyDataType extends MobileVerifyResponseType {
  loading?: boolean;
  fetchError?: boolean;
  isFinished?: boolean;
  isJustVerified?: boolean;
  refetch?: boolean;
  mobileNumber?: string;
  customerId?: string;
}

const initialData: MobileVerifyDataType = {
  loading: true,
  isSuccess: undefined,
  fetchError: false,
  isFinished: false,
  currentMobileNumber: null,
  loginMobileVerifySkipped: false,
  accountMobileVerifySkipped: false,
  isJustVerified: false,
};

export const MobileVerifyContext = createContext(null);

const MobileVerifyProvider = props => {
  const [data, setData] = useState<MobileVerifyDataType>(initialData);

  const setMobileVerifyData = (mobileVerifyData: MobileVerifyDataType) => {
    if (!mobileVerifyData.refetch) {
      setData({ ...data, ...mobileVerifyData });
    } else {
      setData({ ...initialData });
      verifyCustomerMobile({
        onSuccess: response => setData({ ...response, loading: false, isSuccess: true }),
        onError: response =>
          setData({
            ...response,
            loading: false,
            isSuccess: false,
            fetchError: true,
          }),
      });
    }
  };

  return (
    <MobileVerifyContext.Provider
      value={{
        data,
        setMobileVerifyData,
      }}
      {...props}
    />
  );
};

const useMobileVerifyContext = (): {
  data: MobileVerifyDataType;
  setMobileVerifyData: React.Dispatch<React.SetStateAction<MobileVerifyDataType>>;
} => {
  const context = React.useContext(MobileVerifyContext);
  if (context === undefined || context === null) {
    throw new Error('useMobileVerifyContext must be used within a MobileVerifyProvider');
  }
  return context;
};

export { MobileVerifyProvider, useMobileVerifyContext };
